module.exports = __webpack_public_path__ + "img/pdf (1).35665ded.png";